import { brand } from "../../theme/brand";

type Variant =
  | "connected"
  | "not-connected"
  | "synced"
  | "idle"
  | "error"
  | "syncing";

const VARIANTS: Record<Variant, { bg: string; color: string; label: string }> = {
  connected: { bg: "rgba(34,197,94,0.15)", color: "#86efac", label: "Connected" },
  "not-connected": { bg: "rgba(255,255,255,0.09)", color: "rgba(255,255,255,0.72)", label: "Not connected" },
  synced: { bg: "rgba(34,197,94,0.15)", color: "#86efac", label: "Cloud synced" },
  idle: { bg: "rgba(255,255,255,0.09)", color: "rgba(255,255,255,0.72)", label: "Sync idle" },
  error: { bg: "rgba(239,68,68,0.14)", color: "#fca5a5", label: "Sync issue" },
  syncing: { bg: "rgba(59,130,246,0.18)", color: brand.chart.trend, label: "Syncing…" },
};

type Props = {
  variant: Variant;
  label?: string;
};

export function StatusPill({ variant, label }: Props) {
  const { bg, color, label: defaultLabel } = VARIANTS[variant];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "0.22rem 0.6rem",
        borderRadius: 999,
        fontWeight: 700,
        fontSize: "0.8rem",
        border: "1px solid rgba(255,255,255,0.1)",
        background: bg,
        color,
        letterSpacing: "0.01em",
        whiteSpace: "nowrap",
      }}
    >
      {label ?? defaultLabel}
    </span>
  );
}
